module.exports = __webpack_public_path__ + "img/25.0f667f7e.jpg";